import { Injectable } from "@angular/core";
import { db } from "./db";
import { LoggerService } from "../../shared/services/logger.service";

/**
 * Owns full-database (cross-domain) operations so components never touch the
 * Dexie `db` instance directly. Domain-scoped reads/writes belong in their own
 * domain services (job, media, areas, …); this service is for app-wide actions
 * like wiping all locally stored data.
 */
@Injectable({ providedIn: "root" })
export class DatabaseService {
  constructor(private readonly logger: LoggerService) { }

  /**
   * Deletes the entire local IndexedDB database. The app re-creates and
   * re-hydrates it on the next load. Used by the "Clear Device Data" support
   * action; any data that hasn't synced is permanently lost.
   */
  async clearAllData(): Promise<void> {
    this.logger.info("[DatabaseService] Clearing all local data...");
    try {
      await db.delete();
      this.logger.info("[DatabaseService] Local data cleared.");
    } catch (error) {
      this.logger.error("[DatabaseService] Failed to clear local data.", error);
      throw error;
    }
  }
}
